<button mat-mini-fab class="mat-mini-fab-map-control" (click)="zoomOut()" [matTooltip]="'map.control_zoom_out.tooltip' | translate"
  matTooltipPosition="left" matTooltipShowDelay="1000">
  <mat-icon>remove</mat-icon>
</button>
